import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipModule } from '../../directives/tooltip/tooltip.module';
import { WidgetHeaderComponent } from './widget-header.component';

@NgModule({
  declarations: [WidgetHeaderComponent],
  imports: [CommonModule, TooltipModule],
  exports: [WidgetHeaderComponent]
})
export class WidgetHeaderModule { }
